import { render } from "./SelectLessonPopup.vue?vue&type=template&id=394c2aaa&scoped=true"
import script from "./SelectLessonPopup.vue?vue&type=script&lang=js"
export * from "./SelectLessonPopup.vue?vue&type=script&lang=js"

import "./SelectLessonPopup.vue?vue&type=style&index=0&id=394c2aaa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394c2aaa"]])

export default __exports__